(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('EnvOrderTplSearch', EnvOrderTplSearch);

    EnvOrderTplSearch.$inject = ['$resource'];

    function EnvOrderTplSearch($resource) {
        var resourceUrl =  'api/_search/env-orders-tpl/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
